import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: currentColor;
  width: 23px;
  height: 13px;
`

export const TableIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.27606 12C0.919471 12 0.617647 11.8765 0.370588 11.6294C0.123529 11.3824 0 11.0805 0 10.7239V1.27606C0 0.919471 0.123529 0.617647 0.370588 0.370588C0.617647 0.123529 0.919471 0 1.27606 0H10.7239C11.0805 0 11.3824 0.123529 11.6294 0.370588C11.8765 0.617647 12 0.919471 12 1.27606V10.7239C12 11.0805 11.8765 11.3824 11.6294 11.6294C11.3824 11.8765 11.0805 12 10.7239 12H1.27606ZM5.47059 7.90729H1.05882V10.7239C1.05882 10.7874 1.07918 10.8394 1.11988 10.8801C1.16059 10.9208 1.21265 10.9412 1.27606 10.9412H5.47059V7.90729ZM6.52941 7.90729V10.9412H10.7239C10.7874 10.9412 10.8394 10.9208 10.8801 10.8801C10.9208 10.8394 10.9412 10.7874 10.9412 10.7239V7.90729H6.52941ZM5.47059 6.84847V3.80082H1.05882V6.84847H5.47059ZM6.52941 6.84847H10.9412V3.80082H6.52941V6.84847ZM1.05882 2.74218H10.9412V1.27606C10.9412 1.21265 10.9208 1.16059 10.8801 1.11988C10.8394 1.07918 10.7874 1.05882 10.7239 1.05882H1.27606C1.21265 1.05882 1.16059 1.07918 1.11988 1.11988C1.07918 1.16059 1.05882 1.21265 1.05882 1.27606V2.74218Z"
        fill="white"
      />
    </Svg>
  )
}
